import React from 'react';
import { useApiClient, useFetch, useFetchImmutable } from '@marageti/z4-lib';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import UserProfileView from './user-profile-view';

type UserProfileContainerProps = {
  travelerId: string | undefined
  contextMenuProps: Parameters<typeof UserProfileView>[0]['contextMenuProps']
};

const UserProfileContainer = ({
  travelerId,
  contextMenuProps,
}: UserProfileContainerProps) => {
  const apiClient = useApiClient();
  const traveler = useFetch<Traveler>(apiClient.peopleClient.getTraveler, [travelerId], !!travelerId);
  const countryCodes = useFetchImmutable<CountryCodeMap>(apiClient.standardsClient.getCountryCodes, [], true);

  return (
    <UserProfileView
      countryCodes={countryCodes}
      traveler={traveler}
      contextMenuProps={contextMenuProps}
    />
  );
};

export default UserProfileContainer;
